import { Button } from '@bbri/ui';
import { Dialog } from 'primereact/dialog';
import React from 'react';

export const ConfirmDialog = (
  {
    t,
    formService,
    isVisible,
    onCancel,
    onConfirm,
    isOnMobile
  }) => (
  <Dialog
    header={formService.t(t, "ui_confirmation_header", true)}
    visible={isVisible}
    modal
    focusOnShow={false}
    style={isOnMobile ? { width: "95%" } : { width: "450px" }}
    footer={
      <div style={{display: 'flex', justifyContent: 'flex-end', gap: '2px'}}>
        <Button className="confirm-button" onClick={onCancel}>
          {formService.t(t, "ui_input_no", true)}
        </Button>
        <Button className="confirm-button" id="newForm" onClick={onConfirm}>
          {formService.t(t, "ui_input_yes", true)}
        </Button>
      </div>
    }
    onHide={onCancel}
  >
    <div className="confirmation-content">
      <i
        className="pi pi-exclamation-triangle p-mr-3"
        style={{ fontSize: "2rem" }}
      />
      <span>{formService.t(t, "ui_new_form_confirmation_body", true)}</span>

    </div>

  </Dialog>
);